export default __webpack_public_path__ + "static/radeel-bbd70f79316b20f174607e98474d78c1.png";